import Swiper from 'swiper/dist/js/swiper.min';

$('.main-slider').each((index, element) => {
	let $component = $(element);
	let $page = $component.closest('.page');
	let $slider = $component.find('.js-slider');
	let $slideCounter = $component.find('.js-main-slider-index');

	let slider = new Swiper($slider[0], {
		slidesPerView: 1,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	slider.on('slideChange', () => {
		$slideCounter.text(slider.realIndex + 1);
	});

	$page.on('page:show', () => {
		slider.update();
	});
});
